export default __webpack_public_path__ + "static/media/AstroneFi.3d2c500d.svg";